import { APP_PATHS } from './route.constant';

export const SIDEBAR_MENUS = [
  {
    name: 'sidebarMenu.home',
    link: APP_PATHS.Dashboard,
    icon: 'dashboard',
  },
  {
    name: 'sidebarMenu.partners',
    link: APP_PATHS.Partners,
    icon: 'domain',
    permission: 'view_installers',
    xemexOnly: true,
  },
  {
    name: 'sidebarMenu.partnerships',
    link: APP_PATHS.Partnerships,
    icon: 'handshake',
    permission: 'view_partnerships',
  },
  {
    name: 'sidebarMenu.services',
    link: APP_PATHS.Services,
    icon: 'payment',
    permission: 'view_services',
    xemexOnly: true,
  },
  {
    name: 'sidebarMenu.alarms',
    link: APP_PATHS.Alarms,
    icon: 'alarm',
  },
  {
    name: 'sidebarMenu.installations',
    link: APP_PATHS.Installations,
    icon: 'electric_bolt',
    permission: 'view_installations',
    section: 'sidebarMenu.fleet',
    xemexOnly: true,
  },
  {
    name: 'sidebarMenu.installationGroups',
    link: APP_PATHS.InstallationGroups,
    icon: 'workspaces',
    permission: 'view_installation_groups',
    section: 'sidebarMenu.fleet',
  },
  {
    name: 'sidebarMenu.locations',
    link: APP_PATHS.Locations,
    icon: 'home_work',
    permission: 'view_locations',
    section: 'sidebarMenu.fleet',
  },
  {
    name: 'sidebarMenu.devices',
    link: APP_PATHS.Devices,
    icon: 'router',
    permission: 'view_device',
    section: 'sidebarMenu.fleet',
  },
  {
    name: 'sidebarMenu.dataExport',
    link: APP_PATHS.DataExport,
    icon: 'download',
    permission: 'export_device_data',
    section: 'sidebarMenu.fleet',
  },
];

export const SIDEBAR_MENUS_BOTTOM = [
  {
    name: 'sidebarMenu.firmwareManagement',
    link: APP_PATHS.FirmwareManagement,
    icon: 'system_update',
    permission: 'firmware_manager',
    xemexOnly: true,
  },
  {
    name: 'sidebarMenu.myCompany',
    link: APP_PATHS.MyCompany,
    icon: 'apartment',
  },
  {
    name: 'sidebarMenu.settings',
    link: APP_PATHS.Settings,
    icon: 'settings',
    xemexOnly: true,
  },
];
